// Observable Version
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseDataService } from './data.base.service';
import { environment } from '../../../environments/environment';
import { GetLocaleAndBrandInfoResponse, ValidateFallAlertPhoneNumberResponse, ValidateContactPhoneNumberResponse, GetLocaleAndBrandInfoInput, ContactMap, GetFallAlertContactMappingResponse, EnvironmentConfig } from '../../models/fall-alert/fall-alert-interfaces';
import { FallAlertConfirmationType } from '../../models/fall-alert/fall-alert-constants';
import { ConfigurationDataService } from './data.configuration.service';

@Injectable()
export class FallAlertDataService extends BaseDataService {
    constructor(private _http: HttpClient,
        private _apiConfig: ConfigurationDataService) {
        super();
    }

    // TODO: Validate Contact optout/fallAlert/contactRegister should probably be merged into a single CF.
    validateContactPhoneNumber(contactConfirmationId: string, phoneNumber: string): Observable<ValidateContactPhoneNumberResponse>  {
        const data = {
            contactConfirmationId: contactConfirmationId,
            phoneNumber: phoneNumber
        };
        return this._http.post<ValidateContactPhoneNumberResponse>(`${environment.cloudCoreApiUrl}/validateContactPhoneNumber`, data);
    }

    validateFallAlertPhoneNumber(alertId: string, phoneNumber: string): Observable<ValidateFallAlertPhoneNumberResponse>  {
        const data = {
            alertId: alertId,
            phoneNumber: phoneNumber
        };
        return this._http.post<ValidateFallAlertPhoneNumberResponse>(`${environment.cloudCoreApiUrl}/validateFallAlertPhoneNumber`, data);
    }

    validateContactOptOutPhoneNumber(phoneNumber: string): Observable<void>  {
        const data = {
            phoneNumber: phoneNumber
        };
        
        return this._http.post<any>(`${environment.cloudCoreApiUrl}/validateContactOptOutPhoneNumber`, data);
    }

    getLocaleAndBrandInfo(id: string, confirmationType: FallAlertConfirmationType): Observable<GetLocaleAndBrandInfoResponse> {
        const data: GetLocaleAndBrandInfoInput = {
            id: id,
            confirmationType: confirmationType
        };

        return this._http.post<GetLocaleAndBrandInfoResponse>(`${environment.cloudCoreApiUrl}/getLocaleAndBrandInfo`, data);
    }

    setAlertAcknowledged(alertId: string, phoneNumber: string): Observable<any> {
        const data = {
            alertId: alertId,
            phoneNumber: phoneNumber
        };

        return this._http.post(`${environment.cloudCoreApiUrl}/setAlertAcknowledged`, data);
    }

    confirmContact(confirmId: string, phoneNumber: string): Observable<any> {
        const data = {
            id : confirmId,
            phoneNumber: phoneNumber
        };
        return this._http.post(`${environment.cloudCoreApiUrl}/confirmContact`, data);
    }

    getFallAlertContactMapping(optOutValidationToken: string, phoneNumber: string): Observable<GetFallAlertContactMappingResponse> {
        const data = {
            phoneNumber: phoneNumber,
            optOutValidationToken: optOutValidationToken
        };
        return this._http.post<GetFallAlertContactMappingResponse>(`${environment.cloudCoreApiUrl}/getFallAlertContactMapping`, data); 
    }

    deleteFallAlertContact(uid: string, contactId: string): Observable<any> {
        const data = {
            uid : uid,
            contactId : contactId,
        };
        return this._http.post(`${environment.cloudCoreApiUrl}/deleteFallAlertContact`, data)
    }

    getUserIpInfo() : Observable<any> {
        return this._http.get(`${environment.cloudCoreApiUrl}/api/v1/ipInfo`)
    }
}
